import { createDetailStore } from './createDetailStore';
import { createProjectsApi } from './projectsApi';

const store = createDetailStore(createProjectsApi());

export const useProjectDetail = () => store;
